function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}
$(document).ready(function(){

   function addItem(form_id) {
     var data = $('#'+form_id).serialize()
     console.log('data: ', data)
     if (!data && window._selectedVariantId) {
       data = 'id=' + window._selectedVariantId
       console.log('data: ', data)
     }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data,
        success: Shopify.onSuccess,
        error: Shopify.onError
      });
   }

   $( '.modal' ).fancybox();

   // if contact_posted param is in url pop up thank you modal
   if ( getParameterByName( 'contact_posted' ) == 'true' ) {
     $.fancybox.open([{
       'href': '#modal_thank_you'
     }]);
   }

   $(".addtocart").click(function(e){

      var elem = $(this)
      $(elem).prop("disabled", true)
      console.log('atc: ', e)

      e.preventDefault();
      addItem('add-item-form');

   });

   Shopify.onSuccess = function() {

      var elem = $('.addtocart');

      elem.removeAttr("disabled");

      var quantity = parseInt(jQuery('[name="quantity"]').val(), 10) || 1;

      $(elem).prop("disabled", false)
      var cartCount =  parseInt($('#current-count').text()) + quantity;
      console.log('---> ', $('#current-count'))
      if (cartCount > 0) { $('#current-count')[0].style.background = '#7B955E'; }
      else { $('#current-count')[0].style.background = '#2222224d'; }
      $('.cart-count').text(cartCount)
	  $('#add-to-cart-msg').hide().addClass('success').html('Added to cart! <a href="/cart" title="view cart">View cart and check out &raquo;</a>').fadeIn();

    };

    Shopify.onError = function(jqXHR, textStatus, errorThrown){
      var response = $.parseJSON(jqXHR.responseText);
      $('#add-to-cart-msg').addClass('error').text(response.description).fadeIn('fast');
    };

    Shopify.fullMessagesFromErrors = function(errors) {
      var fullMessages = [];
      jQuery.each(errors, function(attribute, messages) {
        jQuery.each(messages, function(index, message) {
          fullMessages.push(attribute + ' ' + message);
        });
      });
      return fullMessages;
    };

})

jQuery(window).load(function(){



  $('#homepage_slider').flexslider({
    touch: false,
    
    controlNav: false,
    animation: "fade",
    
    prevText: 'Prev',
    nextText: 'Next',
    slideshow: true,
    slideshowSpeed: 5*1000,
  });



  $('.gallery').flexslider({
    selector: 'img',
  });

  $("select.loc_on_change").change(function(){
  	if($(this).attr("value") == "#") return false;
  	window.location = $(this).attr("value");
  });

  
});

jQuery(document).ready(function($){

  $('.dropdown').fancySelect();

  $('.nav-icon a').click(function() {
    $('.toggle-menu').toggleClass('active');
  });

  $('#product .thumbs a').click(function(){
    
    $('#placeholder').attr('href', $(this).attr('href'));
    $('#placeholder img').attr('src', $(this).attr('data-original-image'))
    
    $('#zoom-image').attr('href', $(this).attr('href'));
    return false;
  });

  // $('.zoom').magnificPopup({type:'image'});

  $('.zoom').fancybox({
  	'fitToView': false,
  });

  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })

  $("li.nav-dropdown").hover(function(){
    $(this).children('.nav-dropdown').show();
    $(this).children('.nav-dropdown').stop();
    $(this).children('.nav-dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.nav-dropdown').stop();
    $(this).children('.nav-dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });

  var tabs = $('ul.tabs > li > a');
  tabs.each(function(i) {
    jQuery(this).unbind('click.smoothscroll')
    .click(function(e) {
         var contentLocation = $(this).attr('href');
    	 if(contentLocation.charAt(0)=="#") {
  		tabs.removeClass('active');
  		$(this).addClass('active');
  		$(contentLocation).show().addClass('active').siblings().hide().removeClass('active');
    	 }
      return false;
    });
  });

  selectCallback = function(variant, selector) {
    var $product = $('#product-' + selector.product.id);

    if (!variant) {
      var _selector = selector.selectors.find(e => e.name.match(/size/i));
      if (!_selector) return;

      var _selectedValue = _selector.element.value
      var _variant = selector.product.variants.find(v => v.options.includes(_selectedValue));

      var _productOptions = selector.product.options.map(option => option.toLowerCase())
      var _leadTimeIndex = _productOptions.indexOf('lead time')
      var _variantLeadTime = _variant.options[_leadTimeIndex]
      var _leadTimeSelector = selector.selectors.find(e => e.name.match(/lead time/i))
      var _leadTimeSelectorOptionIndex = _leadTimeSelector.values.indexOf(_variantLeadTime)
      _leadTimeSelector.element.selectedIndex = _leadTimeSelectorOptionIndex
      window._selectedVariantId = _variant.id
      console.log(_selectedVariantId)
      if (_variant) variant = _variant
    }

    // update price

    if(variant){
      		var Pid =variant.id
				var WCP_JSON=[];
					if(document.getElementsByClassName('wcp_json_'+Pid).length){
					  WCP_JSON=JSON.parse(document.getElementsByClassName('wcp_json_'+Pid)[0].innerText);
					  for(var tempwcp=0; tempwcp < WCP_JSON.variants.length; tempwcp++){
						if(variant.id==WCP_JSON.variants[tempwcp].id){
						  variant.price=WCP_JSON.variants[tempwcp].price;
						  variant.compare_at_price=WCP_JSON.variants[tempwcp].compare_at_price;
						}
					  }
					}
    }
    
    var $price = $( '.price' );
    if ( variant.compare_at_price != null ) {
    	$price.find( 'del' ).text( Shopify.formatMoney( variant.compare_at_price ) );
    }
    else {
    	$price.find( 'del' ).text( '' );
    }

    if (variant) {
      var $thumbs = $('.thumbs');
      var selection = $.trim( variant.option1.replace( /\(.*?\)/g, '' ) );
      //var selection = variant.option1;

      // update image
      $thumbs.find( 'img[alt="' + selection + '"]' ).parent( 'a' ).click();

      // update price
      if (variant && variant.price == 0) {
      	$( 'h2#price-preview span' ).html( '' );
      }
      else {
        $( 'h2#price-preview span' ).html( Shopify.formatMoney( variant.price ) );
      }
      if (variant && variant.available == true) {
        $( '.btn.btn-add-to-cart' ).removeClass( 'hidden' );
        $( '.btn.btn-unavailabile' ).addClass( 'hidden' );
      }
      else {
        $( '.btn.btn-add-to-cart' ).addClass( 'hidden' );
        $( '.btn.btn-unavailabile' ).removeClass( 'hidden' );
      }
    }


  };

}); // end document ready

/* jQuery css bezier animation support -- Jonah Fox */

;(function($){

  $.path = {};

  var V = {
    rotate: function(p, degrees) {
      var radians = degrees * Math.PI / 180,
        c = Math.cos(radians),
        s = Math.sin(radians);
      return [c*p[0] - s*p[1], s*p[0] + c*p[1]];
    },
    scale: function(p, n) {
      return [n*p[0], n*p[1]];
    },
    add: function(a, b) {
      return [a[0]+b[0], a[1]+b[1]];
    },
    minus: function(a, b) {
      return [a[0]-b[0], a[1]-b[1]];
    }
  };

  $.path.bezier = function( params, rotate ) {
    params.start = $.extend( {angle: 0, length: 0.3333}, params.start );
    params.end = $.extend( {angle: 0, length: 0.3333}, params.end );

    this.p1 = [params.start.x, params.start.y];
    this.p4 = [params.end.x, params.end.y];

    var v14 = V.minus( this.p4, this.p1 ),
      v12 = V.scale( v14, params.start.length ),
      v41 = V.scale( v14, -1 ),
      v43 = V.scale( v41, params.end.length );

    v12 = V.rotate( v12, params.start.angle );
    this.p2 = V.add( this.p1, v12 );

    v43 = V.rotate(v43, params.end.angle );
    this.p3 = V.add( this.p4, v43 );

    this.f1 = function(t) { return (t*t*t); };
    this.f2 = function(t) { return (3*t*t*(1-t)); };
    this.f3 = function(t) { return (3*t*(1-t)*(1-t)); };
    this.f4 = function(t) { return ((1-t)*(1-t)*(1-t)); };

    /* p from 0 to 1 */
    this.css = function(p) {
      var f1 = this.f1(p), f2 = this.f2(p), f3 = this.f3(p), f4=this.f4(p), css = {};
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( this.p1[0]*f1 + this.p2[0]*f2 +this.p3[0]*f3 + this.p4[0]*f4 +.5 )|0;
      css.y = this.y = ( this.p1[1]*f1 + this.p2[1]*f2 +this.p3[1]*f3 + this.p4[1]*f4 +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };

  $.path.arc = function(params, rotate) {
    for ( var i in params ) {
      this[i] = params[i];
    }

    this.dir = this.dir || 1;

    while ( this.start > this.end && this.dir > 0 ) {
      this.start -= 360;
    }

    while ( this.start < this.end && this.dir < 0 ) {
      this.start += 360;
    }

    this.css = function(p) {
      var a = ( this.start * (p ) + this.end * (1-(p )) ) * Math.PI / 180,
        css = {};

      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( Math.sin(a) * this.radius + this.center[0] +.5 )|0;
      css.y = this.y = ( Math.cos(a) * this.radius + this.center[1] +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };

  $.fx.step.path = function(fx) {
    var css = fx.end.css( 1 - fx.pos );
    if ( css.prevX != null ) {
      $.cssHooks.transform.set( fx.elem, "rotate(" + Math.atan2(css.prevY - css.y, css.prevX - css.x) + ")" );
    }
    fx.elem.style.top = css.top;
    fx.elem.style.left = css.left;
  };

})(jQuery);
